import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core/index'
import { orderReserve } from '../../../../helpers/restHelpers'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { withRouter } from 'react-router-dom'

class Component extends React.Component {
    state = { open: false, sizeSelected: '', loading: false, openNoDoor:false }

    handleClickOpen = () => {
        if (!this.props.doorSizeId)
            this.setState({ openNoDoor: true })
        else
            this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false, sizeSelected: '' })
    }

    handleSizeSelect = (e) => {
        if (e === null) {
            this.handleClose(true)
        } else {
            this.setState({ sizeSelected: e })
        }
    }

    confirm = () => {
        this.setState({ loading: true })
        orderReserve(this.props.orderId, this.state.sizeSelected.id)
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.orderReserveSuccessTitle,
                        message: strings.orderReserveSuccess,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.orderReserveButton}
                </div>

                <Dialog
                    open={this.state.openNoDoor}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderReserveDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.orderReserveNoDoorDialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openNoDoor: false })} color="primary">
                            {strings.close}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderReserveDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.orderReserveDoorDialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>

            </div>
        )
    }
}

export default withRouter(Component)
